import { useEffect, useMemo, useState } from 'react';
import { worker } from '../../../../app.worker';
import WebWorker from 'src/WebWorker';
import { ChartItemType, MainObjectType, SelectedTagTypes, TimestampsTypes } from './types';

type Props = {
  timestamps: TimestampsTypes;
  selectedTags: SelectedTagTypes[];
  startDate: string;
  endDate: string;
  aggregationTypePayload: 'two_hour' | 'five_min' | 'thirty_min' | null;
};

export const useChartData = ({
  timestamps,
  selectedTags,
  startDate,
  endDate,
  aggregationTypePayload,
}: Props) => {
  const [data, setData] = useState<any>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    if (!selectedTags || selectedTags.length === 0) return;

    setIsLoading(true);
    let completedRequests = 0;
    const collectedData: any[] = [];

    const webWorker = new WebWorker(worker);

    webWorker.onmessage = (e: MessageEvent) => {
      const { status, error } = e.data;

      if (status === 'success') {
        collectedData.push(e.data.response);
      } else {
        console.error(error);
      }
      completedRequests++;
      if (completedRequests === selectedTags.length) {
        setData(collectedData);
        setIsLoading(false);
      }
    };

    selectedTags.forEach((tag) => {
      if (tag?.gatewayId) {
        webWorker.postMessage({
          gatewayId: tag?.gatewayId,
          startDate: timestamps.fromDate ? startDate : null,
          endDate: timestamps.toDate ? endDate : null,
          measurements: tag?.inputId,
          aggregationType: aggregationTypePayload,
          apiUrl: import.meta.env.VITE_STREAMETRIC_API,
        });
      }
    });

    return () => {
      webWorker.terminate();
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timestamps, selectedTags, aggregationTypePayload]);

  const formatedNewData = useMemo(
    () =>
      data.map((item: ChartItemType) => {
        const dataObj = Object.entries(item?.data);
        const dataEntry = dataObj[0];
        const tagId = dataEntry[0];
        const valuesObj: MainObjectType = dataEntry[1];
        const { values } = valuesObj;

        return { tagId, values };
      }),
    [data]
  );

  return { data: formatedNewData, isLoading };
};
